export default __webpack_public_path__ + "static/media/326.1ecf012b.jpg";